import { render, staticRenderFns } from "./area-api.md?vue&type=template&id=1d420dd8&"
import script from "./area-api.md?vue&type=script&lang=js&"
export * from "./area-api.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d420dd8')) {
      api.createRecord('1d420dd8', component.options)
    } else {
      api.reload('1d420dd8', component.options)
    }
    module.hot.accept("./area-api.md?vue&type=template&id=1d420dd8&", function () {
      api.rerender('1d420dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/api/area-api.md"
export default component.exports